module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "authors-note"
    }
  }, [_c('h1', [_vm._v("Author’s Note")]), _vm._v(" "), _c('p', [_vm._v("The Gullah-Geechee people originally came from western/central Africa and have lived in the low country of South Carolina and Georgia since the colonization of America. They are fascinating and personable; holding strong to their beliefs, heritage, traditions and language. They speak a sea island ‘creole’ which is a combination of African/English.")]), _vm._v(" "), _c('p', [_vm._v("This novel has some conversations using the ‘Gullah’ and ‘Geechee’ languages, but it’s not completely authentic. It was written in a manner to be more understandable to the reader.")]), _vm._v(" "), _c('p', [_vm._v("The author respects the ways, customs and the language of the Gullah-Geechee people.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 75
// module chunks = 0